// extracted by mini-css-extract-plugin
module.exports = {"container":"SelectedEndpointTag_container__1-cHa","label":"SelectedEndpointTag_label__1rziA"};